import React, { useEffect, useState } from "react"
import Breadcrumb from "../../../shared/components/atoms/breadcrumb/breadcrumb"
import ContentHeaderMG from "../../molecules/content-header-mg/content-header-mg"
import SectionCardArticlesMG from "../../molecules/section-card-articles-mg/section-card-articles-mg"
import "./content-mg.scss"

const ContentMG = props => {
  const articleBase = 6
  // const [activeCategory, setCategory] = useState(localStorage.getItem("initFilter"));
  /** hooks*/
  const [activeCategory, setCategory] = useState("lo-ultimo")
  const [numArticles, setnumArticles] = useState(articleBase)
  const [valueSerched, setSerched] = useState("")
  const [typeActive, setTypeActive] = useState("todos")
  const [categoryFilterTitleActive, setcategoryFilterTitleActive] = useState(
    null
  )
  const [itemsFilter, setItemsFilter] = useState([])

  /** initial tags */

  useEffect(() => {
    if (typeof window !== `undefined`) {
      setCategory(sessionStorage.getItem("slugFilterMagazin"))
      // filter();

      return
    } else {
      setCategory("lo-ultimo")
      return
    }
  }, [])
  const featuredArticles = props.contennInfo.filter(info =>
    info.categorias.some(
      ({ slug }) => slug.toLowerCase() === "articulos-usuarias"
    )
  )

  const [infoFilter, setinfoFilter] = useState(() => {
    if (
      typeof window !== `undefined` &&
      sessionStorage.getItem("slugFilterMagazin") !== null &&
      sessionStorage.getItem("slugFilterMagazin") !== "lo-ultimo"
    ) {
      return props.contennInfo.filter(info =>
        info.categorias.some(
          ({ slug }) =>
            slug.toLowerCase() ===
            sessionStorage.getItem("slugFilterMagazin").toLowerCase()
        )
      )
    } else {
      if (
        activeCategory === "lo-ultimo" ||
        activeCategory === "" ||
        sessionStorage.getItem("slugFilterMagazin") === "lo-ultimo"
      ) {
        return props.contennInfo
      } else {
        return props.contennInfo.filter(
          info =>
            info.categorias[0].slug
              .toLowerCase()
              .indexOf(activeCategory.toLowerCase()) > -1
        )
      }
    }
  })

  const HandleSetTypeActive = typeArticle => {
    setnumArticles(articleBase)
    setTypeActive(typeArticle)
    if (typeArticle === "todos") {
      setItemsFilter(infoFilter)
    } else {
      var infoFilterAux = infoFilter.filter(
        info => info?.etiquetas[0].slug === typeArticle
      )
      setItemsFilter(infoFilterAux)
    }
  }

  const persistCategory = (newSlug, newTitle) => {
    setTypeActive("todos")
    setnumArticles(articleBase)
    sessionStorage.setItem("slugFilterMagazin", newSlug)
    sessionStorage.setItem("titleFilterMagazin", newTitle)
    setcategoryFilterTitleActive(newTitle)
  }

  useEffect(() => {
    if (
      sessionStorage.getItem("slugFilterMagazin") !== null &&
      sessionStorage.getItem("slugFilterMagazin") !== "lo-ultimo"
    ) {
      setItemsFilter(
        props.contennInfo.filter(info =>
          info.categorias.some(
            ({ slug }) =>
              slug.toLowerCase() ===
              sessionStorage.getItem("slugFilterMagazin").toLowerCase()
          )
        )
      )
    } else {
      if (
        activeCategory === "lo-ultimo" ||
        activeCategory === "" ||
        sessionStorage.getItem("slugFilterMagazin") === "lo-ultimo"
      ) {
        setItemsFilter(props.contennInfo)
      } else {
        setItemsFilter(
          props.contennInfo.filter(
            info =>
              info.categorias[0].slug
                .toLowerCase()
                .indexOf(activeCategory.toLowerCase()) > -1
          )
        )
      }
    }
  }, [activeCategory])

  return (
    <div className="f-magazin">
      {props.infoCategory.categorias.map((categoria, index) => {
        return (
          <ContentHeaderMG
            contennInfo={infoFilter}
            setinfoFilter={setinfoFilter}
            mobile={props.mobile}
            banner={
              categoria.bannerArticulo ? categoria.bannerArticulo[0] : null
            }
            banner2={categoria.bannerDeInterna}
            activeCategory={activeCategory}
            slug={categoria.slug}
            titulo={categoria.titulo}
            key={index}
            categories={props.infoCategory.categorias}
            setCategory={setCategory}
            persistCategory={persistCategory}
            titlePage={props.infoCategory.titulo}
            slugPage={props.infoCategory.slug}
            articleBase={articleBase}
            autopauta={props.infoCategory.autopauta1}
            itemsFilter={itemsFilter}
            infoReal={props.contennInfo}
            setnumArticles={setnumArticles}
            setSerched={setSerched}
            setItemsFilter={setItemsFilter}
          />
        )
      })}
      <div className="f-breadcrum-position">
        <Breadcrumb mobile={props.mobile} />
      </div>
      <SectionCardArticlesMG
        itemsFilter={itemsFilter}
        numArticles={numArticles}
        setnumArticles={setnumArticles}
        articleBase={articleBase}
        typesArticles={props.infoCategory.filtroSuperior}
        typeActive={typeActive}
        setTypeActive={HandleSetTypeActive}
        valueSerched={valueSerched}
        setModalState={props.setModalState}
        featuredArticles={featuredArticles}
        autoPautaGrid={props.infoCategory.autopautasDelGrid}
        mobile={props.mobile}
        activeCategory={activeCategory}
        categoryFilterTitleActive={categoryFilterTitleActive}
      />
    </div>
  )
}

export default ContentMG
